export default __webpack_public_path__ + "./images/pt.2a03e7b8.png";